"use strict";
var _InquiryImpl_data;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class InquiryImpl {
    constructor(deserialized) {
        _InquiryImpl_data.set(this, {});
        tslib_1.__classPrivateFieldSet(this, _InquiryImpl_data, deserialized.data, "f");
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _InquiryImpl_data, "f");
    }
}
_InquiryImpl_data = new WeakMap();
exports.default = InquiryImpl;
//# sourceMappingURL=Inquiry.js.map